<template>
  <PageTemplate>
    <h1>Profile</h1>
    <div class="row">
      <div class="col-md-6">
        <v-card title="2 Step Verification">
          <template v-if="codeSent">
            <p class="text--primary">
              Enter the code that we sent to
              <span class="text--lg">{{ emailAddress }}</span>
            </p>
            <v-pincode
              v-model="pincode"
              placeholder="0"
            />
            <br>
            <v-button
              class="mt-auto"
              size="lg"
              is-block
              :disabled="pincode.length !== 4"
              @click="submit2FA"
            >
              Submit
            </v-button>
            <v-button
              color="transparent"
              is-block
              @click="goBackToSendCode"
            >
              Cancel
            </v-button>
          </template>
          <template v-else>
            <form
              action
              @submit.prevent="sendCode"
            >
              <p
                class="text--primary"
              >
                Please enter your mobile number and we will send you the verification code.
              </p>
              <v-fieldset
                id="mobileNo2fa"
                v-model="mobileNo2fa"
                text="Mobile Number"
                type="tel"
                pattern="(\+614\d{8}|\+(?!610?4)\d*)"
                placeholder="+61491570006"
                is-required
              />
              <v-button
                class="mt-auto"
                size="lg"
                is-submit
              >
                Send Verification Code
              </v-button>
            </form>
          </template>
        </v-card>

        <v-button
          color="transparent"
          @click="goBackToHome"
        >
          Cancel
        </v-button>
      </div>
    </div>
  </PageTemplate>
</template>
<script>
  import PageTemplate from "@/templates/Page/index.vue";
  import Pincode from "@/molecules/Pincode";
  import Button from "@/atoms/Button";
  import Card from "@/molecules/Card";
  import Fieldset from "@/molecules/Fieldset";
  import {buildBreadCrumb} from "@/common/tableFunctions";
  import routes from "@/common/routes";

  import {
    MANAGE_REMIND,
    VERIFY_CODE,
    SEND_2FA_SETUP_CODE
  } from "@/store/actions.type";
  import {PURGE_AUTH} from "@/store/mutations.type";

  export default {
    name: "Profile2fa",
    components: {
      'v-button': Button,
      'v-fieldset': Fieldset,
      'v-card': Card,
      "v-pincode": Pincode,
      PageTemplate
    },
    data() {
      return {
        emailAddress: '',
        verificationCode: null,
        codeSent: false,
        pincode: "",
        mobileNo2fa: '',
        enabling2FA: true
      };
    },
    mounted() {
      this.updateBreadCrumb();
      this.mobileNo2fa = this.$store.state.auth.twoFactorAuth.tf_mobile_number;
    },
    methods: {
      updateBreadCrumb: function () {
        let breadcrumbs = [];
        breadcrumbs['Dashboard'] = routes.DASHBOARD;
        breadcrumbs['Profile'] = routes.PROFILE;
        breadcrumbs['2 Step Verification'] = '';
        this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
      },
      sendCode() {
        let requestData = {
          //tf_email: this.emailAddress,
          tf_mobile_number: this.mobileNo2fa,
          tf_type: "sms"
        };
        // THis method is called when user clicks on "send Verification Code"
        this.$store
          .dispatch(SEND_2FA_SETUP_CODE, requestData)
          .then(res => {
            if (res) {
              this.codeSent = true;
              // clear already entered code.
              this.pincode = '';
            }
          })
          .catch(error => {
            this.$notify({
              title: 'Error',
              text: 'Something went wrong while sending auth code.',
              type: 'error'
            });
          });
      },
      submit2FA() {
        let requestData = {};
        requestData.auth_code = this.pincode;
        if (this.enabling2FA) {
          requestData.tf_mobile_number = this.mobileNo2fa;
        }

        this.$store.dispatch(VERIFY_CODE, requestData).then(res => {
          if (res) {
            this.goBackToHome();
          }
        });
      },
      goBackToHome() {
        this.$router.push({name: "dashboard"});
      },
      goBackToSendCode() {
        this.codeSent = false;
      }
    }
  };
</script>
